var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3274 10.2896L13.3932 13.3553M10.3274 10.2896C8.12106 12.496 4.54379 12.496 2.33744 10.2896C0.131011 8.08322 0.131011 4.50594 2.33744 2.29959C4.54379 0.0931691 8.12106 0.0931691 10.3274 2.29959C12.5338 4.50594 12.5338 8.08322 10.3274 10.2896Z",
    stroke: "#6E6E80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.dc3da61e82f972cb51e3ecfe5135ce2c.svg";
export { ForwardRef as ReactComponent };